import React from 'react'
import { Chip, Grid, Paper } from '@material-ui/core'
import clsx from 'clsx'
import GetAppIcon from '@material-ui/icons/GetApp'
import { useBudgetStyles } from '../../Budget/styles'

export enum BillState {
  Sale = 'Sale',
  Budge = 'Budge'
}

type TBill = {
  date: string
  plan: string
  value: number
  state: BillState
}

interface IBillProps {
  bill: TBill
}

export function BillStateToText(state: BillState): string {
  if (state === BillState.Sale) {
    return 'Pago'
  } else if (state === BillState.Budge) {
    return 'Orçamento'
  } else {
    return ''
  }
}

const BillCard = ({ bill }: IBillProps): JSX.Element => {
  const classes = useBudgetStyles()

  return (
    <Paper elevation={0} className={classes.root}>
      <Grid container justify="space-around" alignItems="center">
        <Grid xs={3} className={classes.name} style={{ textAlign: 'left' }}>
          {bill.date}
        </Grid>
        <Grid xs={3} className={classes.value} style={{ textAlign: 'center' }}>
          {bill.plan}
        </Grid>
        <Grid xs={2} className={classes.name} style={{ textAlign: 'center' }}>
          {bill.value.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL'
          })}{' '}
          - mês
        </Grid>
        <Grid xs={3} style={{ textAlign: 'center' }}>
          <Chip
            style={{ minWidth: 100 }}
            className={clsx('', {
              [classes.paid]: bill.state === BillState.Sale,
              [classes.payable]: bill.state === BillState.Budge
            })}
            label={BillStateToText(bill.state)}
          />
        </Grid>
        <Grid xs={1} style={{ textAlign: 'right' }}>
          <GetAppIcon className={classes.icon} />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default BillCard
